class MainHeader {
  constructor() {
    this.header = document.querySelector('[data-header]');
    this.burgerTrigger = document.querySelector('[data-burger-trigger]');
    this.burgerContent = document.querySelector('[data-burger-content]');
    this.searchTrigger = document.querySelector('[data-search-trigger]');
    this.searchPanel = document.querySelector('[data-search-panel]');
    this.searchInput = document.querySelector('[data-search-input]');
    this.searchResults = document.querySelector('[data-search-results]');
    this.searchResultTemplate = document.querySelector('[data-search-result-template]');
    this.megamenuTriggers = document.querySelectorAll('[data-megamenu-trigger]');
    this.megamenus = document.querySelectorAll('[data-megamenu]');
    
    this.isHomePage = document.body.classList.contains('template-index');
    
    this.init();
  }

  init() {
    // Прозрачность хедера при скролле
    this.header.classList.add('header--transparent');
    window.addEventListener('scroll', this.handleScroll.bind(this));

    // Бургер меню
    document.addEventListener('toggleBurgerMenu', () => {
      this.burgerContent.classList.toggle('is-active');
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-burger-trigger]') && 
          !event.target.closest('[data-burger-content]') && 
          this.burgerContent.classList.contains('is-active')) {
        this.burgerContent.classList.remove('is-active');
        document.querySelector('[data-burger-trigger]').classList.remove('is-active');
      }
    });

    // Поиск
    this.searchTrigger.addEventListener('click', this.toggleSearch.bind(this));
    this.searchInput.addEventListener('input', this.handleSearch.bind(this));

    // Мега-меню
    this.megamenuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => this.showMegamenu(trigger.dataset.megamenuTrigger));
      trigger.addEventListener('mouseleave', () => this.hideMegamenu(trigger.dataset.megamenuTrigger));
    });

    this.megamenus.forEach(menu => {
      menu.addEventListener('mouseenter', () => this.showMegamenu(menu.dataset.megamenu));
      menu.addEventListener('mouseleave', () => this.hideMegamenu(menu.dataset.megamenu));
    });

    // Закрытие при клике вне элементов
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  handleScroll() {
    if (window.scrollY > 50) {
      this.header.classList.add('header--scrolled');
      this.header.classList.remove('header--transparent');
    } else {
      this.header.classList.remove('header--scrolled');
      this.header.classList.add('header--transparent');
    }
  }

  toggleSearch() {
    const isActive = this.searchPanel.classList.contains('is-active');

    if (isActive) {
      this.closeSearch();
    } else {
      this.searchPanel.classList.add('is-active');
      this.searchInput.focus();
      this.closeBurger();
    }
  }

  handleSearch() {
    const query = this.searchInput.value.trim();

    if (query.length < 3) {
      this.searchResults.classList.remove('is-active');
      return;
    }

    // Здесь должен быть запрос к API Shopify для поиска товаров
    // Пример результатов:
    const results = [
      {
        url: '/products/example-1',
        image: 'https://example.com/image-1.jpg',
        title: 'Product 1',
        price: '$99.99'
      },
      {
        url: '/products/example-2',
        image: 'https://example.com/image-2.jpg',
        title: 'Product 2',
        price: '$149.99'
      }
    ];

    this.renderSearchResults(results);
  }

  renderSearchResults(results) {
    this.searchResults.innerHTML = '';

    results.forEach(result => {
      const element = this.searchResultTemplate.content.cloneNode(true);
      const link = element.querySelector('.search-panel__result');
      const image = element.querySelector('.search-panel__result-image');
      const title = element.querySelector('.search-panel__result-title');
      const price = element.querySelector('.search-panel__result-price');

      link.href = result.url;
      image.src = result.image;
      image.alt = result.title;
      title.textContent = result.title;
      price.textContent = result.price;

      this.searchResults.appendChild(element);
    });

    this.searchResults.classList.add('is-active');
  }

  showMegamenu(type) {
    const megamenu = document.querySelector(`[data-megamenu="${type}"]`);
    if (megamenu) {
      megamenu.classList.add('is-active');
    }
  }

  hideMegamenu(type) {
    const megamenu = document.querySelector(`[data-megamenu="${type}"]`);
    if (megamenu) {
      megamenu.classList.remove('is-active');
    }
  }

  closeBurger() {
    this.burgerContent.classList.remove('is-active');
  }

  closeSearch() {
    this.searchPanel.classList.remove('is-active');
    this.searchResults.classList.remove('is-active');
    this.searchInput.value = '';
  }

  handleOutsideClick(event) {
    // Закрытие поиска при клике вне
    if (
      !event.target.closest('[data-search-trigger]') &&
      !event.target.closest('[data-search-panel]') &&
      this.searchPanel.classList.contains('is-active')
    ) {
      this.closeSearch();
    }
  }
}

// Инициализация при загрузке страницы
window.addEventListener('DOMContentLoaded', () => {
  new MainHeader();
}); 